<script>
    import Chart from 'chart.js';
    import {generateChart} from 'vue-chartjs';

    import { mapGetters } from 'vuex';

    Chart.defaults.barWithShadow = Chart.defaults.bar
    Chart.controllers.barWithShadow = Chart.controllers.bar.extend({
        draw: function (ease) {
            Chart.controllers.bar.prototype.draw.call(this, ease)
            var ctx = this.chart.ctx
            ctx.save()
            ctx.shadowColor = 'rgba(0,0,0,0.2)'
            ctx.shadowBlur = 7
            ctx.shadowOffsetX = 5
            ctx.shadowOffsetY = 7
            ctx.responsive = true
            Chart.controllers.bar.prototype.draw.apply(this, arguments)
            ctx.restore()
        }
    })

    const BarShadow = generateChart('bar-with-shadow', 'barWithShadow')

    export default {
        extends: BarShadow,

        props: ['data'],

        data() {
            return {

            }
        },

        computed: {
            ...mapGetters({
                colors: 'getThemeColors',
            }),

            options() {
                return {
                    legend: {
                        position: 'bottom',
                        labels: {
                            padding: 30,
                            usePointStyle: true,
                            fontSize: 12
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    lineWidth: 1,
                                    color: 'rgba(0,0,0,0.1)',
                                    drawBorder: false
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 20
                                }
                            }
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        backgroundColor: this.colors.foregroundColor,
                        titleFontColor: this.colors.primaryColor,
                        borderColor: this.colors.separatorColor,
                        borderWidth: 0.5,
                        bodyFontColor: this.colors.primaryColor,
                        bodySpacing: 10,
                        xPadding: 15,
                        yPadding: 15,
                        cornerRadius: 0.15,
                    },
                };
            },
        },

        mounted() {
            this.renderChart(this.data, this.options)
        }
    }
</script>
